import React, { useEffect, useState } from "react";
import MyDropList from "../../tools/MyDropList";
import StatCard from "../../tools/StatCard";
import {
  BadgeDollarSign,
  CircleArrowOutUpRight,
  TvMinimalPlay,
} from "lucide-react";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { getAppodealStats } from "../../service/getAppodealStats";
import { getDateRange } from "../../service/getDateRange";

export default function AdRevenue() {
  const [date, selectDate] = useState("today");
  const options = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "7days" },
    { label: "Last 30 Days", value: "30days" },
  ];

  async function loadStats() {
    const range = getDateRange(date);
    const date_to = range.dateTo;
    const date_from = range.dateFrom;
    const data = await getAppodealStats({ date_from, date_to });

    console.log(data);
  }

  useEffect(() => {
    loadStats();
  }, [date]);

  return (
    <div className="space-y-4 flex flex-col">
      {/* top  */}
      <div className="flex items-center justify-end">
        {/* filter by date */}
        <div className="max-w-150">
          <MyDropList
            options={options}
            value={date}
            onChange={(date) => selectDate(date)}
          />
        </div>
      </div>
      {/* metrics cards */}
      <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-10">
        <StatCard
          color="#413aff"
          lable="CTR"
          icon={AdsClickIcon}
          value="100%"
          info={[
            " CTR = (Number of clicks ÷ Number of impressions) × 100 ",
            " Clicks = how many times people clicked",
            " Impressions = how many times it was shown",
            "",
          ]}
          graphData={[12, 18, 20, 17, 13, 10, 12, 18, 28, 42, 58, 40]}
        />
        <StatCard
          color="#32f161"
          lable="Total Clicks"
          icon={TouchAppIcon}
          value="109"
          info={[
            " Total Clicks means the total number of times users clicked on your ad, link, button, or content.",

            "",
          ]}
          graphData={[12, 18, 20, 1, 42, 58, 40]}
        />
        <StatCard
          color="#7643f8"
          lable="Total Impressions"
          icon={TvMinimalPlay}
          value="109"
          info={[
            " Total Impressions means the total number of times your ad, content, or page was displayed to users.",
            "An impression is counted every time it appears on screen, even if the user does not click it.",
            "",
          ]}
          graphData={[12, 18, 20, 1, 42, 58, 40]}
        />
        <StatCard
          color="#fb8a3f"
          lable="Revenue"
          icon={BadgeDollarSign}
          value="109"
          info={[
            "Revenue means the total amount of money earned from your ads, app.",
            "",
          ]}
          graphData={[12, 18, 20, 1, 42, 58, 40]}
        />
      </div>
    </div>
  );
}
